// DS: IL3.9
import React from 'react';

export const Unlock: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="90"
      height="88"
    >
      <defs>
        <linearGradient id="unlock-a" x1="-5.147%" x2="17.48%" y1="-10.91%" y2="81.195%">
          <stop offset="0%" stopColor="#FFF"></stop>
          <stop offset="100%" stopColor="#00E59B"></stop>
        </linearGradient>
        <linearGradient id="unlock-b" x1="50%" x2="43.038%" y1="54.901%" y2="45.132%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0"></stop>
          <stop offset="100%" stopColor="#FFF"></stop>
        </linearGradient>
        <linearGradient id="unlock-c" x1="0%" x2="79.655%" y1="23.128%" y2="68.181%">
          <stop offset="0%" stopColor="#FFF"></stop>
          <stop offset="100%" stopColor="#C2C2C2"></stop>
        </linearGradient>
        <linearGradient id="unlock-e" x1="9.367%" x2="50%" y1="-32.681%" y2="67.278%">
          <stop offset="0%" stopColor="#161A1F" stopOpacity="0"></stop>
          <stop offset="100%" stopColor="#161A1F"></stop>
        </linearGradient>
        <path
          id="unlock-d"
          d="M36 67.736l3.77-7.883-1.108-1.36-.583-4.223 2.65-3.683L45.013 50l3.416 2.71.571 4.375-2.616 3.496-1.588.621L44.214 70z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="url(#unlock-a)"
          fillRule="nonzero"
          d="M36.284 44l6.9-26.096 3.752-3.804 5.14-1.4 5.137 1.389 3.765 3.79 1.385 5.192-1.77 7.507L65.858 32 68 23.075l-2.142-8.046-5.83-5.866L52.068 7l-7.963 2.164-5.817 5.884L31 42.567z"
        ></path>
        <path
          fill="url(#unlock-b)"
          fillRule="nonzero"
          d="M39 16.599l1.931.401 4.058-4.584 5.517-1.35L51 9l-6.54 1.714z"
        ></path>
        <path
          fill="url(#unlock-c)"
          fillRule="nonzero"
          d="M25.772 34l35.334 9.61.023.048 7.392 1.994L73 54.923l-6.568 24.66-8.1 5.417-7.318-2.02-.05.035-35.972-9.76L11 64.624l6.65-25.23z"
        ></path>
        <use fill="url(#unlock-e)" xlinkHref="#unlock-d"></use>
        <path
          fill="#161A1F"
          fillRule="nonzero"
          d="M70.717 32l3.094 4.213L79 35.717l-4.208 3.082.491 5.201-3.082-4.208-5.201.491 4.213-3.094z"
        ></path>
      </g>
    </svg>
  );
};
Unlock.displayName = 'Unlock';
